// Imports the useEffect hook from React for side effects, and useLocation from react-router-dom to access the location object which represents the current URL.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Exports a ScrollToTop component that automatically scrolls the user to the top of the page on route changes.
export function ScrollToTop() {
  // Destructures pathname from the location object, so we have access to the current path.
  const { pathname } = useLocation();

  // useEffect hook to perform side effects. In this case, to scroll to the top of the window.
  useEffect(() => {
    // window.scrollTo scrolls the window to a particular set of coordinates in the document.
    // Here, it's used to scroll to the top of the page (0,0) whenever the pathname changes.
    window.scrollTo(0, 0);
  // The dependency array includes pathname, meaning this effect will re-run every time the pathname changes.
  }, [pathname]);

  // This component does not render anything to the DOM, hence it returns null.
  // Its sole purpose is to execute the side effect of scrolling the window to the top when the route changes.
  return null;
}
